import React, { useRef, useEffect, useState } from 'react';
import '../App.css';
import './Home.css';

export default function Home({ go }) {
  const dividerRef = useRef(null);
  const [showDividerAnimation, setShowDividerAnimation] = useState(false);

  useEffect(() => {
    const divider = dividerRef.current;
    if (!divider) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setShowDividerAnimation(entry.isIntersecting);
      },
      { threshold: 0.3 }
    );

    observer.observe(divider);

    return () => {
      observer.unobserve(divider);
    };
  }, []);

  return (
    <main className="page-home">
      {/* HERO */}
      <section className="hero" aria-label="Hero principal">
        <img
          className="hero-img"
          src={`${process.env.PUBLIC_URL}/img/posiblesimageneshome/home2.jpg`}
          alt="Camión en carretera"
        />
        <div className="hero-overlay"></div>

        <div className="container hero-grid">
          <div className="hero-content">
            <div className="hero-text">
              <h1>Transporte seguro y rápido a nivel nacional</h1>
              <p className="subtitle">
                Confía en nuestra experiencia para mover tu carga
              </p>
              <div className="hero-actions">
                <button
                  className="btn btn-cta"
                  onClick={() => go('contacto')}
                >
                  Cotiza tu envío
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICIOS */}
      <section id="servicios" className="services container">
        <h2>Servicios</h2>
        <p className="lead">Soluciones completas para cada tipo de carga</p>

        <div className="services-showcase">
          <div className="service-showcase-card urban-showcase">
            <div className='service-text-box'>
              <h3>Transporte Urbano</h3>
              <p>Ofrecemos soluciones integrales de distribución dentro de ciudades y zonas metropolitanas, optimizando la última milla, las entregas programadas y la recolección local, garantizando rapidez, control y cumplimiento en cada envío.</p>
            </div>
            <img
              className="showcase-image"
              src={`${process.env.PUBLIC_URL}/img/serviciourbano.jpg`}
              alt="Transporte Urbano"
            />
          </div>

          <div className="service-showcase-card carretera-showcase">
            <img
              className="showcase-image"
              src={`${process.env.PUBLIC_URL}/img/posiblesimageneshome/home3.jpg`}
              alt="Transporte por Carretera"
            />
            <div className='service-text-box'>
              <h3>Transporte por Carretera</h3>
              <p>Ofrecemos servicios de transporte de mercancías a nivel regional y nacional, con rutas optimizadas, manejo especializado de carga general y frágil, envíos urgentes y altos estándares de seguridad durante todo el recorrido.</p>
            </div>
          </div>
        </div>

        <div className="services-grid">
          <article className="service-card">
            <h3>Transporte de mercancía</h3>
            <p>Flota moderna y rutas optimizadas para entregas seguras.</p>
          </article>

          <article className="service-card">
            <h3>Última milla</h3>
            <p>Recogidas y entregas confiables en menos tiempo.</p>
          </article>

          <article className="service-card">
            <h3>Carga frágil</h3>
            <p>Manejo especializado y embalaje protector.</p>
          </article>

          <article className="service-card">
            <h3>Transporte urgente</h3>
            <p>Soluciones exprés a nivel nacional.</p>
          </article>
        </div>

      </section>

      {/* SEPARADOR CON ANIMACIÓN */}
      <section 
        className={`services-divider ${showDividerAnimation ? 'visible' : ''}`}
        ref={dividerRef}
      >
        <div className="divider-content">
          <img 
            className="divider-image"
            src={`${process.env.PUBLIC_URL}/img/338posibleportada.jpeg`}
            alt="Separador"
          />
          <div className="divider-overlay"></div>
          <div className="divider-text">
            <h2>Tu carga en buenas manos</h2>
            <p>Confía en nuestros años de experiencia y profesionalismo</p>
          </div>
        </div>
      </section>

      <section id="por-que" className="why-choose">
        <div className="container">
          <h2 className="section-title">¿Por qué elegirnos?</h2>
          <div className="why-grid" role="list">
            <article className="why-card" role="listitem">
              <div className="icon" aria-hidden="true">
                {/* Shield icon */}
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2l7 3v5c0 5-3.8 9.74-7 12-3.2-2.26-7-7-7-12V5l7-3z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3>Seguridad garantizada</h3>
              <p className="why-desc">Protocolos de carga y descarga, sistemas de sujeción y seguimiento en tiempo real para minimizar riesgos y garantizar la integridad de todos los envíos.</p>
              <img
              className="showcase-image"
              src={`${process.env.PUBLIC_URL}/img/snyfrente.jpeg`}
              alt="Transporte Urbano"
            />
            </article>

            <article className="why-card" role="listitem">
              <img
              className="showcase-image"
              src={`${process.env.PUBLIC_URL}/img/homeseccion3.3.jpg`}
              alt="Transporte Urbano"
            />
              <div className="icon" aria-hidden="true">
                {/* Clock icon */}
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.2"/>
                  <path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3>Cumplimiento de tiempos</h3>
              <p className="why-desc">Rutas optimizadas, monitoreo constante y coordinación logística para cumplir con ventanas de entrega y acuerdos SLA.</p>
            </article>

            <article className="why-card" role="listitem">
              <div className="icon" aria-hidden="true">
                {/* Map pin icon */}
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 21s8-4.5 8-11a8 8 0 10-16 0c0 6.5 8 11 8 11z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3>Cobertura nacional</h3>
              <p className="why-desc">Operamos en las principales regiones del país con hubs regionales y rutas interprovinciales que conectan grandes centros urbanos y zonas remotas.</p>
              <img
              className="showcase-image"
              src={`${process.env.PUBLIC_URL}/img/Fotohomeseccion3.jpeg`}
              alt="Transporte Urbano"
            />
            </article>

            <article className="why-card" role="listitem">
              <img
              className="showcase-image"
              src={`${process.env.PUBLIC_URL}/img/imagen3.4.jpg`}
              alt="Transporte Urbano"
            />
              <div className="icon" aria-hidden="true">
                {/* Headset icon */}
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 13v-1a9 9 0 0118 0v1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M3 15v3a2 2 0 002 2h1v-7H5a2 2 0 00-2 2zM21 15v3a2 2 0 01-2 2h-1v-7h1a2 2 0 012 2z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3>Atención personalizada</h3>
              <p className="why-desc">Equipos dedicados de atención y coordinadores logísticos disponibles para diseñar soluciones a la medida y soporte 24/7 en envíos críticos.</p>
            </article>
          </div>
        </div>
      </section>

      {/* Sección 3: Tipos de carga que transportamos */}
      <section id="tipos-carga" className="cargo-types">
        <div className="container">
          <h2 className="section-title">Tipos de carga que transportamos</h2>

          <div className="cargo-grid">
            <div className="cargo-card">
              <div>
                <h4>Carga frágil</h4>
                <p className="cargo-desc">Manejo con embalaje especial, anclajes y seguimiento para minimizar golpes y vibraciones durante el transporte.</p>
              </div>
            </div>

            <div className="cargo-card">
              <div>
                <h4>Carga pesada</h4>
                <p className="cargo-desc">Equipos y unidades con capacidad de carga reforzada y procedimientos de izaje para cargas sobredimensionadas.</p>
              </div>
            </div>

            <div className="cargo-card">
              <div>
                <h4>Electrodomésticos</h4>
                <p className="cargo-desc">Transporte seguro con embalaje especializado y rutas directas para entrega rápida y sin inconvenientes.</p>
              </div>
            </div>

            <div className="cargo-card">
              <div>
                <h4>Mercancía general</h4>
                <p className="cargo-desc">Servicios flexibles para cargas LTL y FTL con opciones de seguimiento y entrega programada.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

    </main>
  );
}
